import React from 'react';
import { NextPage } from 'next';
import loadNamespaces from 'next-translate/loadNamespaces';
import { trackActions } from '../../api';

import Profile from '../../containers/Profile';
import { withAuthSync } from '../../utils/auth';
import { VirpPageContext } from '../_app';

const ProfilePage: NextPage<{ profileId: number }> = ({ profileId }) => (
  <Profile profileId={profileId} />
);

ProfilePage.getInitialProps = async (ctx: VirpPageContext) => {
  const {
    req,
    store,
    query: { profileId: id },
    token,
  } = ctx;
  const { id: userID } = store?.getState().user;
  const getTranslations = await loadNamespaces({
    ...ctx,
    pathname: '/profile/[profileId]',
  });

  const profileId = Number(id);

  if (req) {
    await Promise.all([
      store?.dispatch(
        trackActions.fetchUserTracks(Number(profileId), { page: 1 }, token),
      ),
    ]);
  }

  return {
    profileId: profileId || Number(userID),
    ...getTranslations,
  };
};

export default withAuthSync(ProfilePage);
